export default __webpack_public_path__ + "9addd69664aaf8358414885e426d01c8.jpg";